import type { CharacterConfig } from '../../src/characters/types';
import modelUrl from './runtime/model/odette.fbx?url';
import bodyUrl from './runtime/textures/diffuse/body.png?url';
import body01Url from './runtime/textures/diffuse/body-01.png?url';
import faceUrl from './runtime/textures/diffuse/face.png?url';
import hairUrl from './runtime/textures/diffuse/hair.png?url';
import eyeUrl from './runtime/textures/diffuse/eye.png?url';
import bodyLightmapUrl from './runtime/textures/lightmap/body.png?url';
import body01LightmapUrl from './runtime/textures/lightmap/body-01.png?url';
import hairLightmapUrl from './runtime/textures/lightmap/hair.png?url';
import bodyRampUrl from './runtime/textures/ramp/body.png?url';
import body01RampUrl from './runtime/textures/ramp/body-01.png?url';
import hairRampUrl from './runtime/textures/ramp/hair.png?url';
import faceSdfUrl from './runtime/textures/sdf/face.png?url';
import faceShadowUrl from './runtime/textures/shadow/face.png?url';

export const odetteCharacter = {
  id: 'odette', label: 'Odette', slug: 'odette', assetRoot: 'characters/odette/runtime', modelUrl,
  textures: {
    body: bodyUrl, body01: body01Url, face: faceUrl, hair: hairUrl, eye: eyeUrl,
    bodyLightmap: bodyLightmapUrl, body01Lightmap: body01LightmapUrl,
    bodyRamp: bodyRampUrl, body01Ramp: body01RampUrl,
    hairLightmap: hairLightmapUrl, hairRamp: hairRampUrl, faceSdf: faceSdfUrl, faceShadow: faceShadowUrl,
  },
  materialRules: [
    { mesh: 'EyeStar', diffuse: 'face', glow: 'eye' },
    { materialPattern: /_Mat_Hair$/i, diffuse: 'hair', lighting: 'hair', glow: 'subtle' },
    { materialPattern: /_Mat_Dress$/i, diffuse: 'hair', lighting: 'hair', glow: 'subtle' },
    { materialPattern: /_Mat_(Body01|Dress01)$/i, diffuse: 'body01', lighting: 'body01', glow: 'subtle' },
    { materialPattern: /_Mat_Body$/i, diffuse: 'body', lighting: 'body', glow: 'subtle' },
    { materialPattern: /_Mat_Pupil$/i, diffuse: 'eye', glow: 'eye' },
    { meshPattern: /^(Face|Face_Eye)$/, materialPattern: /_Mat_Face$/i, diffuse: 'face', lighting: 'face', maskedEyeGlow: true, faceCheekRim: true },
    { materialPattern: /_Mat_Face$/i, diffuse: 'face' },
    { materialPattern: /_Mat_Brow$/i, diffuse: 'face', lighting: 'face' },
  ],
  shading: {
    hairShadowTint: [.875, .875, .875],
    bodyShadowTint: [.875, .875, .875],
    body01ShadowTint: [.9411765, .9411765, .9411765],
    faceShadowColor: [.9529412, .84313726, .8117647],
  },
  outline: { enabled: true, hairColor: 0x24375a, bodyColor: 0x49435f, hairWidth: .008, bodyWidth: .005 },
  capabilities: { faceSdf: true, maskedEyeEmission: true, outline: true },
} as const satisfies CharacterConfig<'odette'>;
